import { Box, Button, Typography } from '@mui/material';
import { ApprovalRequestType } from '../utils/enum';
import ApproveDialog from '../../pending-actions/components/approve-dialog';
import { useEffect, useState } from 'react';

interface IProps {
  id: string;
  setIsRejected: (value: boolean) => void;
  cardStatus: ApprovalRequestType;
  setIsLoading: (value: boolean) => void;
  isLoading: boolean;
}
const PendingActionButtonsComponent = ({
  id,
  setIsRejected,
  cardStatus,
  setIsLoading,
  isLoading
}: IProps): JSX.Element => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };
  const handleReject = (): void => {
    setIsRejected(true);
  };
  const handleApprove = (): void => {
    setIsRejected(false);
    handleClickOpen();
    setIsLoading(false);
  };
  const [status, setStatus] = useState<ApprovalRequestType>(cardStatus);

  useEffect(() => {
    if (cardStatus) {
      setStatus(cardStatus);
    }
  }, [cardStatus]);

  return (
    <>
      <ApproveDialog
        id={id}
        open={open}
        comment=""
        handleClose={handleClose}
        setApprovelStatus={(value: { status: string }) => {
          setStatus(value.status as unknown as ApprovalRequestType);
        }}
      />
      {status === ApprovalRequestType.PENDING ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
            gap: '10px'
          }}
        >
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: 'Be Vietnam Pro',
              lineHeight: '20px',
              letterSpacing: '0.1px',
              alignItems: 'center',
              color: '#CAC4D0'
            }}
          >
            Waiting for approval
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            disabled={isLoading}
            onClick={handleReject}
            sx={{
              borderRadius: '100px',
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: 'Be Vietnam Pro',
              lineHeight: '20px',
              letterSpacing: '0.1px',
              alignItems: 'center',
              color: '#295DAB',
              padding: '10px 24px'
            }}
          >
            Reject
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleApprove}
            disabled={isLoading}
            sx={{
              borderRadius: '100px',
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: 'Be Vietnam Pro',
              lineHeight: '20px',
              letterSpacing: '0.1px',
              alignItems: 'center',
              color: '#295DAB',
              backgroundColor: '#E2ECF6',
              padding: '10px 24px',
              boxShadow: 'none'
            }}
          >
            Approve
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
            gap: '10px'
          }}
        >
          {status === ApprovalRequestType.APPROVED ? (
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: 'Be Vietnam Pro',
                lineHeight: '20px',
                letterSpacing: '0.1px',
                alignItems: 'center',
                color: '#019e09'
              }}
            >
              Approved
            </Typography>
          ) : status === ApprovalRequestType.REJECTED ? (
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: 'Be Vietnam Pro',
                lineHeight: '20px',
                letterSpacing: '0.1px',
                alignItems: 'center',
                color: '#bb0202'
              }}
            >
              Rejected
            </Typography>
          ) : (
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: 'Be Vietnam Pro',
                lineHeight: '20px',
                letterSpacing: '0.1px',
                alignItems: 'center',
                color: '#CAC4D0'
              }}
            >
              Waiting for approval
            </Typography>
          )}
        </Box>
      )}
    </>
  );
};

export default PendingActionButtonsComponent;
